import { STATUS } from "@/constants/statuses";
import type { Observable } from "rxjs";
import { combineLatest, map } from "rxjs";

export const getLoadingStatus = (status: STATUS): STATUS =>
    status === STATUS.VIRGIN ? STATUS.INITIAL_LOADING : STATUS.LOADING;

export const isVirginStatus = (status: STATUS): boolean =>
    status === STATUS.VIRGIN;

export const selectRequestStatus = (
    statuses: Array<Observable<STATUS>>,
    status: STATUS
): Observable<boolean> =>
    combineLatest(statuses).pipe(map((statuses) => statuses.includes(status)));

export const isInitialLoadingStatus = (
    status$: Observable<STATUS>
): Observable<boolean> =>
    status$.pipe(
        map((status) =>
            [STATUS.VIRGIN, STATUS.INITIAL_LOADING].includes(status)
        )
    );
